// Enter all your detials in this file
// Logo images
import logogradient from "./assets/logo_trans.png";
import logo from "./assets/logo_trans.png";
// Profile Image
import profile from "./assets/solomen1.jpg";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import redux from "./assets/techstack/redux.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
import figma from "./assets/techstack/figma.png";
// Porject Images
import wcxImage from "./assets/projects/wcx4.jpg";
import unityAdsImage from "./assets/projects/unityads.jpg";
import appleIbmImage from "./assets/projects/appleibm.jpeg";
import htcImage from "./assets/projects/htc.jpg";

// Logos
export const logos = {
   logogradient: logogradient,
   logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
   name: "Solomon Li",
   tagline: "I build fun apps, and",
   tagline2: "help you integrate mobile SDKs",
   img: profile,
   about: `Now building <a href='https://www.write.cx' target='_blank'>write.cx</a> - a text assistant. <br>
   5 years helping game developers to integrate Unity Ads SDK. <br> 7 years mobile app development.`,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
   linkdein: "https://www.linkedin.com/in/solomon2k/",
   github: "https://www.github.com/",
   twitter: "https://x.com/solomonli6481",
   instagram: "https://www.instagram.com/",
};

// Enter your Work Experience here
export const workDetails = [
   {
      Position: "Fullstack Developer",
      Business: "write.cx is a text assistant",
      Achievement: "Create and Marketing",
      Award: "Achievement: 50 users",
      Company: `Write.CX - Indiepreneurship`,
      Location: "",
      Type: "Fulltime",
      Duration: "Dec 2024 - Now",
   },
   {
      Position: "Product Manager",
      Business: "Intrinsic Ads is a platform on Immersive In Game Ads",
      Achievement: "Create and lead a team of 8",
      Award: "Paused",
      Company: `Intrinsic Ads - Entrepreneurship`,
      Location: "",
      Type: "Fulltime",
      Duration: "Jun 2022 - Mar 2024",
   },
   {
      Position: "Senior Solutions Engineer",
      Business: "Branch is a Mobile Attribution",
      Achievement: "",
      Award: "",
      Company: `Branch`,
      Location: "",
      Type: "Fulltime Regular",
      Duration: "Oct 2020 - Mar 2022",
   },
   {
      Position: "Developer Relations Engineer",
      Business: "Unity Ads is a In Game Ads Solutions",
      Achievement:
         "Help >100 game publishers to integrate Unity Ads SDK, <br>solve their mobile development and data problems",
      Award: "Outstanding Performance x4",
      Company: `Unity`,
      Location: "",
      Type: "Fulltime Regular",
      Duration: "Mar 2016 - Sep 2020",
   },
   {
      Position: "Mobile Application Developer",
      Business: "Apple + IBM programm, develop 100 apps together",
      Achievement: "Implement Mobile Apps with Apple Designers",
      Award: "Manager's Choice Award x2",
      Company: `IBM`,
      Location: "",
      Type: "Fulltime Regular",
      Duration: "2013 - 2016",
   },
   {
      Position: "Software Engineer - Android System",
      Business: "Custom and Maintain Android System Frameworks",
      Achievement: "Android System UI, IrDA app",
      Award: "Employee of the Season",
      Company: `HTC`,
      Location: "",
      Type: "Fulltime Regular",
      Duration: "2011 - 2013",
   },
];

// Enter your Education Details here
export const eduDetails = [
   {
      Position: "",
      Business: "Dalian University of Foreign Languages",
      Achievement: "",
      Award: "",
      Company: `Information Resource Management,  Bachelor`,
      Location: "Dalian, China",
      Type: "Bachelor",
      Duration: "Sep 2004 - Jul 2008",
   },
];

// Tech Stack and Tools
export const techStackDetails = {
   html: html,
   css: css,
   js: js,
   react: react,
   redux: redux,
   sass: sass,
   tailwind: tailwind,
   bootstrap: bootstrap,
   vscode: vscode,
   postman: postman,
   npm: npm,
   git: git,
   github: github,
   figma: figma,
};

// Enter your Project Details here
export const projectDetails = [
   {
      title: "Write CX",
      image: wcxImage,
      description: `A text generation assistant designed to be readily available at your fingertips, seamlessly integrating into any website.`,
      techstack: "HTML/CSS, JavaScript",
      previewLink: "https://www.write.cx",
      githubLink: "",
   },
   {
      title: "Unity Ads",
      image: unityAdsImage,
      description: `Unity Ads is a mobile monetization platform designed to support developers with in-app advertising, ads designed to funnel users to your app, and in-app purchases.`,
      techstack: "Android, iOS, Unity",
      previewLink: "https://unity.com/products/unity-ads",
      githubLink: "",
   },
   {
      title: "Apple + IBM 100 Apps",
      image: appleIbmImage,
      description: `Apple and IBM Forge Global Partnership to Transform Enterprise Mobility. The new IBM MobileFirst for iOS solutions will be built in an exclusive collaboration that draws on the distinct strengths of each company`,
      techstack: "Swift",
      previewLink:
         "https://www.apple.com/newsroom/2014/07/15Apple-and-IBM-Forge-Global-Partnership-to-Transform-Enterprise-Mobility/",
      githubLink: "https://www.linkedin.com/pulse/100-appleibm-apps-changing-way-we-work-richard-paul/",
   },
   {
      title: "HTC Mobile",
      image: htcImage,
      description: `HTC One is a touchscreen-based Android smartphone designed, developed, and manufactured by HTC. The smartphone was unveiled in 2013 and is HTC's seventh flagship smartphone.`,
      techstack: "Android, Java",
      previewLink: "https://www.htc.com/us/go/buy-now-htc-one-m8/",
      githubLink: "https://en.wikipedia.org/wiki/HTC_Desire",
   },
];

// Enter your Contact Details here
export const contactDetails = {
   email: "hi@example.com",
   phone: "+91 12345 67890",
};

export const blogList = [
   {
      title: "Build ChatGPT Agent in Seconds",
      topic: "Prompt Engineering",
      description: "This is a sample blog post description.",
      slug: "build-agent-in-seconds",
      date: "2025-02-26",
   },
   {
      title: "Life Experience Depth Framework",
      topic: "Applied Philosophy, Lifestyle",
      description: "This is a sample blog post description.",
      slug: "experience-depth",
      date: "2025-06-16",
   },
];
